import React from 'react';
import { OrderShipment } from '@jbhi-fi/apis/src/orderTrackingThemeApi/types';
import { ExperienceInformation } from '../ExperienceInformation';
import { ProductInformationProps } from '../ProductInformation/ProductInformationCard';
import { TrackingHistory } from '../TrackingHistory/TrackingHistory';
import { OrderShipmentTransformer } from '../transformers/OrderShipmentTransformer';
import { WhatsComing } from '../WhatsComing';
import { styles } from './TrackingResult.css';
import { isBackOrderConfirmedWithEta, isBackOrderEtaPassed, isShipmentDropShip } from '../backOrderHelpers';

type TrackingContentProps = {
  orderNumber: string;
  shipment: OrderShipment;
  renderingOrder?: Array<'fulfilment' | 'history' | 'whatsComing'>;
  lineItems?: Array<ProductInformationProps>;
};

export const TrackingResultContent = ({
  renderingOrder = ['fulfilment', 'history', 'whatsComing'],
  orderNumber,
  shipment,
  lineItems,
}: TrackingContentProps) => {
  const shouldDisplayHistory = shipment.type === 'PhysicalDelivery' && shipment.isTracked && shipment.history !== null;
  const hideDeliverySubtext = isBackOrderConfirmedWithEta(shipment) || isBackOrderEtaPassed(shipment);

  return (
    <>
      {renderingOrder.map(sectionKey => {
        if (sectionKey === 'fulfilment') {
          return (shipment.messaging?.carrier && shipment.type !== 'BulkyDelivery') || shipment.messaging?.store ? (
            <div key={sectionKey} className={styles.contentSection}>
              <ExperienceInformation
                key={sectionKey}
                status={shipment.status}
                carrier={shipment.messaging.carrier}
                consignmentNumber={shipment.consignmentNumber}
                trackingUrl={shipment.carrierTrackingUrl}
                store={shipment.messaging.store}
                alert={shipment.messaging.template.alert}
                importantText={hideDeliverySubtext ? undefined : shipment.messaging.template.importantText}
                confirmationText={hideDeliverySubtext ? undefined : shipment.messaging.template.confirmationText}
                footer={hideDeliverySubtext ? undefined : shipment.messaging.template.footer}
              />
            </div>
          ) : null;
        }
        if (sectionKey === 'history' && shouldDisplayHistory) {
          return (
            <div className={styles.historySection} key={sectionKey}>
              <TrackingHistory
                historyData={OrderShipmentTransformer.toShipmentHistory(shipment.confirmedAt, shipment.history)}
                carrierTrackingUrl={shipment?.carrierTrackingUrl}
                helpMessaging={shipment.messaging?.template.importantTextHistory}
              />
            </div>
          );
        } else if (sectionKey === 'whatsComing' && lineItems?.length) {
          return (
            <div key={sectionKey} className={styles.contentSection}>
              <WhatsComing
                key={sectionKey}
                orderNumber={orderNumber || shipment.id}
                status={shipment.status}
                lineItems={lineItems}
                isDropShip={isShipmentDropShip(shipment)}
              />
            </div>
          );
        }
        return null;
      })}
    </>
  );
};
